import { render, staticRenderFns } from "./calendar.vue?vue&type=template&id=8d3348fc"
import script from "./calendar.vue?vue&type=script&lang=ts"
export * from "./calendar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiDatePicker: require('/vercel/path0/components/ui/date-picker.vue').default,UiOutlineButton: require('/vercel/path0/components/ui/outline-button.vue').default,UiButton: require('/vercel/path0/components/ui/button.vue').default,FilterBaseFilterCard: require('/vercel/path0/components/filter/base-filter-card.vue').default})
